import { XmlCursorPos, XMLCursorPositions } from './xmlCursorPos.class';
import { XmlToolbox } from '../xmlToolbox.class';
import { DomDummyNodeManager } from '../dummyNodes/domDummyNodeManager.class';

export class XmlCursor {
  xmlDocumentRootNode: Element = undefined;
  domDummyNodeManager = new DomDummyNodeManager();

  public StartPos = new XmlCursorPos();
  public EndPos = new XmlCursorPos();

  /**
   * is there nothing between start and end pos?
   */
  isEmptySelection(): boolean {
    if (this.StartPos.equals(this.EndPos)) {
      return true;
    }
    return false;
  }

  sortStartAndEnd() {
    if (this.StartPos.ActualNode && this.EndPos.ActualNode) {
      if (this.StartPos.ActualNode.isSameNode(this.EndPos.ActualNode)) {
        if (
          this.StartPos.PosAtNode === XMLCursorPositions.CursorInsideTextNode &&
          this.EndPos.PosAtNode === XMLCursorPositions.CursorInsideTextNode &&
          this.StartPos.PosInTextnode > this.EndPos.PosInTextnode
        ) {
          this.swapStartAndEnd();
        }
      } else {
        const compared = this.StartPos.ActualNode.compareDocumentPosition(this.EndPos.ActualNode);
        // tslint:disable-next-line:no-bitwise
        if (!(compared & Node.DOCUMENT_POSITION_FOLLOWING)) {
          this.swapStartAndEnd();
        }
      }
    }
  }

  swapStartAndEnd() {
    const node = this.StartPos.ActualNode;
    const pos = this.StartPos.PosAtNode;
    const text = this.StartPos.PosInTextnode;
    this.StartPos.SetCursor(this.EndPos.ActualNode, this.EndPos.PosAtNode, this.EndPos.PosInTextnode);
    this.EndPos.SetCursor(node, pos, text);
  }

  show() {
    if (window.getSelection) {
      const selection: Selection = window.getSelection();
      this.show2(selection);
    } else {
      throw new Error('showCursor: unable to get "window.getSelection"');
    }
  }

  private show2(selection: Selection) {
    if (!selection) {
      return;
    }

    // Remove all selected classes
    const elems = document.querySelectorAll('.selected');
    [].forEach.call(elems, function(el) {
      el.classList.remove('selected');
    });

    const startSelection = XmlCursorPos.getSelectionForPos(this.StartPos);
    if (this.EndPos && this.EndPos.ActualNode && !this.EndPos.equals(this.StartPos)) {
      // start + end pos
      const endSelection = XmlCursorPos.getSelectionForPos(this.EndPos);
      selection.setBaseAndExtent(startSelection.node, startSelection.offset, endSelection.node, endSelection.offset);
    } else {
      // only start pos
      selection.setPosition(startSelection.node, startSelection.offset);

      // select tag by adding "select" class
      if (this.StartPos.PosAtNode === XMLCursorPositions.CursorOnCompleteNode) {
        const asElem = this.StartPos.ActualNode as Element;
        if (asElem && asElem.classList) {
          asElem.classList.add('selected');
          console.log('selected!');
        } else {
          console.error(`no asElem.classList for select! ${XmlToolbox.GetNodeDebugContext(asElem)}`);
        }
      }
    }
  }
}

export interface SelectionPos {
  node: Node;
  offset: number;
}
